const validatePancreas=(formData)=>

{
const message0= "NICE recommends:-" 

const referMessage = "Refer people using a suspected cancer pathway referral for pancreatic cancer if they are aged 40 and over and have jaundice."

const ctMessage= "Consider an urgent, direct access CT scan (to be done within 2 weeks), or an urgent ultrasound scan if CT is not available, to assess for pancreatic cancer in people aged 60 and over with weight loss and any of the following: (diarrhoea, back pain, abdominal pain, nausea, vomiting,constipation, new‑onset diabetes.)"

if (formData.age>=40 && formData.jaundice)
    {formData.message.pancreas= message0 + referMessage
    formData.twrValid.pancreas=true
    return formData
    }

if (formData.age < 60)
    {
    return formData
    }


if (formData.weightLoss && 
    (formData.cobh ||
     formData.backPain || 
     formData.abdoPain || 
     formData.upperAbdoPain ||
     formData.nausea ||
     formData.vomiting ||
     formData.diabetes)) 
        {
        formData.message.pancreas= message0 + ctMessage
        formData.investigations.push("CT Abdomen")
        return formData
        }

    return formData

}

export default validatePancreas